import { render, staticRenderFns } from "./ViqReportPanel.vue?vue&type=template&id=67dd7144&scoped=true"
import script from "./ViqReportPanel.vue?vue&type=script&lang=js"
export * from "./ViqReportPanel.vue?vue&type=script&lang=js"
import style0 from "./ViqReportPanel.vue?vue&type=style&index=0&id=67dd7144&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd7144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67dd7144')) {
      api.createRecord('67dd7144', component.options)
    } else {
      api.reload('67dd7144', component.options)
    }
    module.hot.accept("./ViqReportPanel.vue?vue&type=template&id=67dd7144&scoped=true", function () {
      api.rerender('67dd7144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqReportPanel.vue"
export default component.exports